import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';
import { ProductPackage } from '../../../core/generated';

@Component({
    selector: 'app-product-confirmation-dialog',
    standalone: true,
    imports: [MaterialModule, CommonModule],
    templateUrl: './product-confirmation-dialog.component.html',
    styleUrl: './product-confirmation-dialog.component.scss'
})
export class ProductConfirmationDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<ProductConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { product: ProductPackage }
  ) { }

  formatCurrencyValueByMonth(value: number | undefined): string {
    if (value === undefined) {
      return '';
    }
    const monthlyValue = value / 12;
    return monthlyValue.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }) + ' /mês';
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
